import { render } from "./MMEditMultilateralAdvisor.vue?vue&type=template&id=8ede6326"
import script from "./MMEditMultilateralAdvisor.vue?vue&type=script&lang=js"
export * from "./MMEditMultilateralAdvisor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__